import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isloggedin'); // Replace with your actual key

  return isLoggedIn ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;